<!-- 专题页文章列表 -->
<template>
  <div class="page-topic-article-list" :class="{ mobile: isMobile }">
    <pull-to @infinite-scroll="getMoreList">
      <div class="header">
        <div class="title">{{ title }}</div>
      </div>
      <div class="main">
        <img :src="headImage" alt="" v-if="headImage && headImageSwitch" class="head-image" />
        <div class="list">
          <div class="article-item" v-for="(article, index) in list" :key="article.id" :class="{ active: id == article.id }" @click="handleArticleClick(article.id)">
            <el-divider v-if="index > 0"></el-divider>
            <div class="flex">
              <div class="left">
                <div class="title">{{ article.title }}</div>
                <div class="date" v-if="article.baoZhiName || article.publishDate">{{ article.baoZhiName }} <span class="point" v-if="article.publishDate"></span> {{ article.publishDate }}</div>
              </div>
              <div class="right" v-if="article.firstImage"><img :src="article.firstImage" alt="" srcset="" /></div>
            </div>
          </div>
        </div>
        <div class="no-more" v-if="list.length === totalElements">没有更多了</div>
      </div>
      <div class="digital-loading" v-if="dataLoading">
        <div class="text">加载中...</div>
      </div>
    </pull-to>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '@api/paperManager'
import PullTo from 'vue-pull-to'
import moment from 'moment'
import { formatDigitalArticle } from '@/utils'
import wxSetting from '@components/common/wxSetting'
export default {
  name: 'TopicArticleList',
  mixins: [wxSetting],
  components: {
    PullTo
  },
  data() {
    return {
      dataLoading: false,
      title: '',
      headImage: '',
      headImageSwitch: 0,
      list: [],
      pageNo: 1,
      pageSize: 15,
      id: '',
      totalElements: -1
    }
  },
  created() {
    this.topicId = this.$route.query.id || ''
    if (this.topicId) {
      this.getList()
      this.getTopicById()
    }
  },
  computed: {
    ...mapState('book', ['isMobile'])
  },
  methods: {
    getMoreList() {
      if (this.list.length === this.totalElements) {
        return
      }
      this.pageNo++
      this.getList()
    },
    initWxConfig() {
      // 初始化微信设置
      let ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        let shareUrl = window.location.href.split('#')[0]
        const wxParams = {
          id: this.topicId,
          currentUrl: shareUrl
        }
        this.getWXConfig(wxParams, api.topicWxShareParams, true, this.title)
      } else {
        console.log('不是微信浏览器')
      }
    },
    handleArticleClick(id) {
      let path = '/digitalArticle'
      let routeUrl = this.$router.resolve({
        path: path,
        query: { id, type: 'paper' }
      })
      window.open(routeUrl.href, '_blank')
    },
    getList() {
      this.dataLoading = true
      const param = {
        topicId: this.topicId,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      api.getArticlePageByTopicId(param).then((res) => {
        this.dataLoading = false
        if (res.status === 200 && res.data.status === 0) {
          let data = res.data.data
          let arr = data.content.map((item) => {
            if (item.publishDate) {
              item.publishDate = moment(item.publishDate).format('YYYY-MM-DD')
            }
            item.content = formatDigitalArticle({ data: { data: item } }).data.data.content
            let matched = item.content.match(/(<img.*?src=")(.*?)(".*?>)/)
            if (matched) {
              item.firstImage = matched[2]
              console.log(item.firstImage)
            }
            return item
          })
          this.list = this.list.concat(arr)
          this.totalElements = data.totalElements
        }
      })
    },
    getTopicById() {
      const param = {
        id: this.topicId
      }
      api.getTopicById(param).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          let data = res.data.data
          this.setTopicDetailData(data)
          document.title = data.name
        }
      })
    },
    setTopicDetailData(data) {
      this.title = data.name
      this.headImage = data.headImage
      this.headImageSwitch = data.headImageSwitch
      this.initWxConfig()
    }
  }
}
</script>

<style lang="scss">
.page-topic-article-list {
  img {
    max-width: 100%;
  }
  width: 600px;
  height: 99%;
  margin: auto;
  border: 1px solid #d2d2d2;
  position: relative;
  .header {
    background-color: #f5f5f5;
    font-size: 14px;
    .title {
      line-height: 40px;
      text-align: center;
    }
  }
  .main {
    overflow: auto;
    .head-image {
      width: 100%;
      margin-bottom: 20px;
      vertical-align: top;
    }
    .article-item {
      width: 100%;
      cursor: pointer;
      padding: 0 20px;
      .left {
        flex-grow: 1;
        margin-right: 15px;
      }
      .title {
        line-height: 36px;
        font-weight: 500;
      }
      .date {
        font-size: 12px;
        line-height: 16px;
        margin-top: 6px;
        display: flex;
        align-items: center;
        .point {
          width: 4px;
          height: 4px;
          opacity: 1;
          background: rgba(196, 196, 196, 1);
          margin: 0 5px;
          border-radius: 50%;
        }
      }
      img {
        display: block;
        width: 120px;
        height: 87px;
        border-radius: 8px;
      }
    }
    .el-divider {
      margin: 15px 0;
      background-color: rgba(239, 239, 239, 1);
    }
  }
  /*修改滚动条样式*/
  div::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    /**/
  }
  div::-webkit-scrollbar-track {
    background: rgb(239, 239, 239);
    border-radius: 2px;
  }
  div::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 10px;
  }
  div::-webkit-scrollbar-thumb:hover {
    background: #333;
  }
  div::-webkit-scrollbar-corner {
    background: #179a16;
  }
  .el-table ::-webkit-scrollbar-corner {
    background: transparent;
  }
  .no-more {
    text-align: center;
    margin: 10px 0;
    color: #999;
  }
}
.page-topic-article-list.mobile {
  border: 0;
  width: 100%;
}
</style>
